var calculate = require('./src/calculator');

var _require = require('./src/config'),
    buyerTypes = _require.buyerTypes,
    countries = _require.countries,
    propertyTypes = _require.propertyTypes;

module.exports = {
  calculate: calculate,
  buyerTypes: buyerTypes,
  countries: countries,
  propertyTypes: propertyTypes
};